import { Icon } from "@sellar-io/components";
import { formatCurrency } from "@sellar-io/common";
import type { OrderLinkFlowGetResponseType } from "@sellar-io/api-v2/types";

interface OrderBannerProps {
  order: OrderLinkFlowGetResponseType;
  onShowDetails?: () => void;
}

export function OrderBanner({ order, onShowDetails }: OrderBannerProps) {
  const itemCount = order.lineItems.reduce(
    (sum, item) => sum + item.quantity,
    0,
  );

  return (
    <div className="w-full bg-white px-5 pt-10 pb-6">
      <div className="mx-auto w-full max-w-md">
        <p className="mb-2 text-xs font-semibold tracking-wide text-zinc-500 uppercase">
          Order #{order.orderReference}
        </p>
        <div className="rounded-2xl bg-white shadow-sm ring-1 ring-zinc-200">
          <div className="flex items-center gap-3 p-4">
            <div className="shrink-0">
              {order.supplierLogoUrl ? (
                <img
                  src={order.supplierLogoUrl}
                  alt={order.supplierName}
                  className="h-10 w-10 rounded-full object-contain"
                />
              ) : (
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-100">
                  <Icon icon="STOREFRONT_OUTLINE" size={1} />
                </div>
              )}
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-semibold text-zinc-800">
                {order.supplierName}
              </p>
              <p className="text-xs text-zinc-500">
                {itemCount} {itemCount === 1 ? "item" : "items"}
              </p>
            </div>
            <div className="shrink-0 text-right">
              <p className="text-sm font-semibold text-zinc-800">
                {formatCurrency(order.totalPence)}
              </p>
              <p className="text-xs text-zinc-500">Total (inc. VAT)</p>
            </div>
          </div>
          {onShowDetails && (
            <div className="border-t border-zinc-100">
              <button
                type="button"
                onClick={onShowDetails}
                className="flex w-full cursor-pointer items-center justify-center gap-1 py-3 text-sm text-zinc-600 hover:text-zinc-800"
              >
                Show order details
                <Icon icon="CHEVRON_RIGHT" size={0.8} />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
